import { AGSResultBuilder } from "ags/integration/builders/results/abstract-ags-result-builder";
import { AGSFeatureTypes } from "ags/integration/schema/ags-spin-response-schema";
import GatewayResult, { GatewayType } from "model/gameplay/records/results/gateway-result";
import Record from "slotworks/model/gameplay/records/record";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";
import { AGSGateWin } from "integration/schema/ags-gate-win";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import Point from "slotworks/utils/geom/point";
import ScatterResult from "slotworks/model/gameplay/records/results/scatter-result";

export class GatewayResultBuilder extends AGSResultBuilder implements ResultBuilder {

    public static BONUS_SYMBOL_ID = "BN";

    public filter(data: any): boolean {
        const win = data as AGSGateWin;

        const isRetrigger = win.featureType === AGSFeatureTypes.FREESPINS_WIN;

        return win.gate || isRetrigger;
    }

    public build(record: Record, data: any): Result[] {
        const agsWin = data as any;
        const result = new GatewayResult("gateway");
        result.cashWon = agsWin.sumWins || 0;
        result.gatewayType = this.getGatewayType(agsWin);

        // This is a hack. There's alot of weird logic that depends on cashWon to decide which bonus round is active.
        result.winAmount = agsWin.winAmount || 0;

        // This is also a hack, the server should send this info back.
        const bonusSymbolPositions = this.getBonusPositions(record as SpinRecord);
        result.matches = bonusSymbolPositions.length;
        result.symbols = bonusSymbolPositions.map(() => GatewayResultBuilder.BONUS_SYMBOL_ID);

        const freespinResults = this.processFreespinData(record, data, result);
        result.freespinsWon = freespinResults[0]?.freespinsWon;
        result.wildsAwarded = agsWin.wildLevel;

        // The dual scatter and gateway results are a consequence of insufficient information / planning up front.
        result.positions = this.getBonusPositions(record as SpinRecord);
        result.symbolType = "BN";

        const scatterResult = new ScatterResult();
        scatterResult.positions = this.getBonusPositions(record as SpinRecord);
        scatterResult.matches = scatterResult.positions.length;
        scatterResult.symbolType = "BN";
        scatterResult.cashWon = agsWin.winAmount;

        // Only return the scatter result if it's a retrigger.
        if (!agsWin.gate) {
            return [scatterResult, ...freespinResults];
        }

        return [result, ...freespinResults];
    }

    protected getBonusPositions(record: SpinRecord) {
        const coords: Point[] = [];

        record.grid.forEach((row, rowIndex) => {
            row.forEach((symbol, columnIndex) => {
                if (symbol === GatewayResultBuilder.BONUS_SYMBOL_ID) {
                    coords.push(new Point(rowIndex, columnIndex));
                }
            });
        });

        return coords;
    }

    protected getGatewayType(agsWin: AGSGateWin) {
        if (agsWin.featureType === AGSFeatureTypes.FREESPINS_WIN) {
            return GatewayType.FREESPINS;
        }
        return GatewayType.MC_BONUS;
    }
}

export default new GatewayResultBuilder();
